const navTrigger = document.querySelectorAll('.navTrigger');

if (navTrigger) {

	navTrigger.forEach( (item) => {
		item.addEventListener('click', () => {
			item.classList.toggle('is-active');
			let targetedNav = item.dataset.nav;
			let nav = document.getElementById(targetedNav);
			nav.classList.toggle('is-active');
		})
	})
}